"use client";
import { component } from "@gnist/component-utils";
import { rowRecipe } from "./styles.css.js";
const Row = component("Row", rowRecipe, "div");
export {
  Row
};
